<div class="filter-chips-container">
  @for (chip of chips(); track chip.selectedOption) {
    <div class="filter-chip">
      <span class="chip-label">
        <span class="chip-label-key">{{ chip.label | translate }}:</span>
        {{ chip.selectedOption | translate }}
      </span>

      <button class="chip-remove-btn" (click)="removeChip(chip)" aria-label="Remove filter">
        <app-icon class="close-icon" [icon]="IconName.CLOSE" />
      </button>
    </div>
  }

  @if (chips().length > 1) {
    <button class="reset-btn" (click)="handleResetAll()">Reset all</button>
  }
</div>
